import OrderCard from './OrderCard';

export default OrderCard;
